import { render, staticRenderFns } from "./CargasSugal.vue?vue&type=template&id=7386acc3&"
import script from "./CargasSugal.vue?vue&type=script&lang=ts&"
export * from "./CargasSugal.vue?vue&type=script&lang=ts&"
import style0 from "./CargasSugal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports